import { TProps } from './types/TProps';
import { Wrapper } from './styles/Wrapper';

export const IconButton = (props: TProps) => {
  const { children, ...rest } = props;
  return <Wrapper {...rest}>{children}</Wrapper>;
};
